import React, { useContext } from "react";
import useDateFormat from "toolkit/useDateFormat";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import CertificationExpectedDateLabelField from "./CertificationExpectedDateLabelField";

const CertificationExpectedDateFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { formatDate } = useDateFormat();

  const { expectedDate } = entity as CertificationInterface;

  return (
    <CertificationExpectedDateLabelField {...{ expectedDate, formatDate }} />
  );
};

export default React.memo(CertificationExpectedDateFieldContainer);
